






import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ServiceCategoryTabMoveButton extends Vue {
  @Prop({ required: true }) private type!: string;

  private get classNames(): { [key: string]: boolean } {
    return {
      "tab-move-button--prev": this.type === "prev",
      "tab-move-button--next": this.type === "next",
    };
  }
}
